//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import list from './dataList.json';
export default {
  name: 'resbdguideholdnumber',
  data(){
     return{
        buildHeadBeans:{
            UnitBean:[]
        },
       floorBeanLists:[],
       houseTypeSetBeanLists:[],
       oldChoose:[0,0,0]
     } 
  },
  mounted(){
      
  },
  computed:{
  
  },
  watch:{
      floorBeanList:{
       handler:function(newval,oldval){
            
            this.floorBeanLists=this.cloneDeepJson(this.floorBeanList)
       },
       deep: true,
       immediate:true
     },
     buildHeadBean:{
       handler:function(newval,oldval){
            this.buildHeadBeans=this.cloneDeepJson(this.buildHeadBean)
       },
       deep: true,
       immediate:true
     },
     houseTypeSetBeanList:{
        handler:function(newval,oldval){
            this.houseTypeSetBeanLists=this.cloneDeepJson(this.houseTypeSetBeanList)
       },
       deep: true,
       immediate:true
        
     },
     isSave:{
       handler:function(newval,oldval){
           if(this.isSave){
              console.log('调用保存',this.isSave)
            
              this.saveData()
              // this.isSaveAndPrint=false
           }
       },
       deep: true
    },
    isRoomhousetype:{
       handler:function(newval,oldval){
           console.log('调用房间',this.isRoomhousetype)
            
           if(this.isRoomhousetype){
              console.log('调用房间',this.isRoomhousetype)
            
              this.handelRoom(this.indexList[0],this.indexList[1],this.indexList[2],this.indexList[3])
       
           }
       },
       deep: true
    },
    isFloorhousetype:{
       handler:function(newval,oldval){
           if(this.isFloorhousetype){
             console.log('调用楼层',this.isFloorhousetype)
            
              this.handelFloor(this.indexList[0],this.indexList[1]) 
             
           }
       },
       deep: true
    },
    isUnitholdhousetype:{
       handler:function(newval,oldval){
           if(this.isUnitholdhousetype){
             console.log('调用户型',this.isUnitholdhousetype)
            
              this.handelHold(this.indexList[0],this.indexList[1],this.indexList[2])
              
           }
       },
       deep: true
    },
  },
  props: {
    buildHeadBean:Object,
    floorBeanList:Array,
    houseTypeSetBeanList:Array,
    model: Object,
    getLangMsg: Function,
    invoke: Function,
    isSave:Number,
    indexList:Array,
    isRoomhousetype:Number,
    isFloorhousetype:Number,
    isUnitholdhousetype:Number,
  },
   created() {
    this.handleToNextStep()
  },
  methods:{
     cloneDeepJson(obj){
         return JSON.parse(JSON.stringify(obj))
      },
     changeSelect(n,nn,nnn){
         this.floorBeanLists[this.oldChoose[0]].unitBeanList[this.oldChoose[1]].roomBeanList[this.oldChoose[2]].isSelect=false
         this.oldChoose=[n,nn,nnn]
         this.floorBeanLists[n].unitBeanList[nn].roomBeanList[nnn].isSelect=true
     },
     clearSelect(){
         this.floorBeanLists[this.oldChoose[0]].unitBeanList[this.oldChoose[1]].roomBeanList[this.oldChoose[2]].isSelect=false
     },
     handleToNextStep: function () {
      console.log('init_data')
      this.invoke('invokeCustomEvent',{content:{ type: 'guideholdnumber_init_data', value:''}})
    },
     getSelectionName(name){
         if(name){
            return name
         }else{
            return '户型选择'
         }
        
     },
     saveData(){
         let roomsList=[],floorsList=[],unitHoldsList=[],houseTypeSetIdsList=[]
          this.floorBeanLists.forEach((i,n)=>{
               if(i.houseTypeSetName){
                   let item={
                      id:i.id,
                      houseTypeSetId:i.houseTypeSetId
                   }
                   floorsList.push(item)
                   houseTypeSetIdsList.push(i.houseTypeSetId)
               }
               i.unitBeanList.forEach((ii,nn)=>{
                   ii.roomBeanList.forEach((iii,nnn)=>{
                        if(iii.houseTypeSetName){
                           let item={
                              id:iii.id,
                              houseTypeSetId:iii.houseTypeSetId
                           }
                           roomsList.push(item)
                           houseTypeSetIdsList.push(iii.houseTypeSetId)
                        }
                  }) 
              })    
          })
          this.buildHeadBeans.unitBeanList.forEach((i,n)=>{ 
               i.unitHoldBeanList.forEach((ii,nn)=>{
                        if(ii.houseTypeSetName){
                           let item={
                              id:ii.id,
                              houseTypeSetId:ii.houseTypeSetId
                           }
                           unitHoldsList.push(item)
                           houseTypeSetIdsList.push(ii.houseTypeSetId)
                        }
              })    
          })
         houseTypeSetIdsList=this.unique(houseTypeSetIdsList)
         let value={
            rooms:roomsList,
            floors:floorsList,
            unitHolds:unitHoldsList,
            houseTypeSetIds:houseTypeSetIdsList,
         }
         let parm={content:{ type:'guideholdnumber_save_data', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
     },
      unique (arr) {
      return Array.from(new Set(arr))
      },
     handelRoom(n,nn,nnn,typeNum){
      //   console.log('this.houseTypeSetBeanLists',this.houseTypeSetBeanLists)
           this.floorBeanLists[n].unitBeanList[nn].roomBeanList[nnn].houseTypeSetName=this.houseTypeSetBeanLists[typeNum].name
           this.floorBeanLists[n].unitBeanList[nn].roomBeanList[nnn].houseTypeSetId=this.houseTypeSetBeanLists[typeNum].id
         //   console.log(n,nn,nnn,typeNum,this.floorBeanLists,this.houseTypeSetBeanLists[typeNum].name,this.houseTypeSetBeanLists[typeNum].id)
     },
     chooseRoom(n,nn,nnn,typeNum,id,houseTypSetId){
      // console.log(id,houseTypSetId,'e')
         //   this.floorBeanLists[n].unitBeanList[nn].roomBeanList[nnn].houseTypeSetName=this.houseTypeSetBeanLists[typeNum].name
         //   this.floorBeanLists[n].unitBeanList[nn].roomBeanList[nnn].houseTypeSetId=this.houseTypeSetBeanLists[typeNum].id
         //   console.log(n,nn,nnn,typeNum,this.floorBeanLists,this.houseTypeSetBeanLists[typeNum].name,this.houseTypeSetBeanLists[typeNum].id)
           let value={
            roomId:id,
            houseTypSetId:houseTypSetId,
            indexList:[n,nn,nnn,typeNum]
         }
         let parm={content:{ type:'guideholdnumber_set_roomhousetypeset', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
      
    },
     handelFloor(n,typeNum){
           this.floorBeanLists[n].houseTypeSetName=this.houseTypeSetBeanLists[typeNum].name
           this.floorBeanLists[n].houseTypeSetId=this.houseTypeSetBeanLists[typeNum].id
         //   console.log(n,typeNum,this.floorBeanLists,this.houseTypeSetBeanLists[typeNum].name,this.houseTypeSetBeanLists[typeNum].id)
             this.floorBeanLists[n].unitBeanList.forEach((i,num)=> {
                i.roomBeanList.forEach((ii,num2 )=> {
                    this.handelRoom(n,num,num2,typeNum)
               });
            });
     },
     chooseFloor(n,typeNum,id,houseTypSetId){
         //   this.floorBeanLists[n].houseTypeSetName=this.houseTypeSetBeanLists[typeNum].name
         //   this.floorBeanLists[n].houseTypeSetId=this.houseTypeSetBeanLists[typeNum].id
         // //   console.log(n,typeNum,this.floorBeanLists,this.houseTypeSetBeanLists[typeNum].name,this.houseTypeSetBeanLists[typeNum].id)
         //     this.floorBeanLists[n].unitBeanList.forEach((i,num)=> {
         //        i.roomBeanList.forEach((ii,num2 )=> {
         //            this.chooseRoom(n,num,num2,typeNum)
         //       });
         //    });
         let value={
            floorId:id,
            houseTypSetId:houseTypSetId,
            indexList:[n,typeNum]
         }
         let parm={content:{ type:'guideholdnumber_set_floorhousetypeset', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
     
    },
     handelHold(n,nn,typeNum){
         this.buildHeadBeans.unitBeanList[n].unitHoldBeanList[nn].houseTypeSetName=this.houseTypeSetBeanLists[typeNum].name
         this.buildHeadBeans.unitBeanList[n].unitHoldBeanList[nn].houseTypeSetId=this.houseTypeSetBeanLists[typeNum].id
          this.floorBeanLists.forEach((i,num)=> {
                i.unitBeanList.forEach((ii,num2 )=> {
                    ii.roomBeanList.forEach((iii,num3 )=> {
                         if(num2==n&&num3==nn){
                             this.handelRoom(num,num2,num3,typeNum)
                         }
                     });
               });
            });
     },
      chooseHold(n,nn,typeNum,id,houseTypSetId){
         // this.buildHeadBeans.unitBeanList[n].unitHoldBeanList[nn].houseTypeSetName=this.houseTypeSetBeanLists[typeNum].name
         // this.buildHeadBeans.unitBeanList[n].unitHoldBeanList[nn].houseTypeSetId=this.houseTypeSetBeanLists[typeNum].id
         //  this.floorBeanLists.forEach((i,num)=> {
         //        i.unitBeanList.forEach((ii,num2 )=> {
         //            ii.roomBeanList.forEach((iii,num3 )=> {
         //                 if(num2==n&&num3==nn){
         //                     this.chooseRoom(num,num2,num3,typeNum)
         //                 }
         //             });
         //       });
         //    });
         //  console.log(n,nn,typeNum,this.floorBeanLists,this.houseTypeSetBeanLists[typeNum].name,this.houseTypeSetBeanLists[typeNum].id)
      //console.log(id,houseTypSetId,'e')
     
        let value={
            unitHoldId:id,
            houseTypSetId:houseTypSetId,
            indexList:[n,nn,typeNum]
         }
         let parm={content:{ type:'guideholdnumber_set_unitholdhousetypeset', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
     
    },
  }
}
